"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _core = require("@popperjs/core");
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _portal = _interopRequireDefault(require("../portal"));
var _set_ref = _interopRequireDefault(require("../../utils/set_ref"));
var _use_direction = _interopRequireDefault(require("../../direction/use_direction"));
var _prop_types = _interopRequireDefault(require("./prop_types"));
var _core2 = require("@emotion/core");
var _excluded = ["anchorEl", "children", "fixed", "flip", "id", "keepMounted", "modifiers", "onChangePlacement", "open", "placement", "portal", "portalContainer", "role", "style", "transition"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * Translate our popover placement to popover.js placement
 */
function translatePlacement(placement, isRTL) {
  var _ref = placement.split('-'),
    _ref2 = _slicedToArray(_ref, 2),
    first = _ref2[0],
    last = _ref2[1];
  var horizontalPlacements = ['leading', 'left', 'right', 'trailing'];
  var isHorizontal = horizontalPlacements.includes(first);
  if (isHorizontal) {
    // Translate leading and trailing to left/right, and flip if rtl
    return [['leading', 'left'].includes(first) ? isRTL ? 'right' : 'left' : isRTL ? 'left' : 'right', last].filter(Boolean).join('-');
  } else {
    // Flip start/end if RTL
    return [first, isRTL ? last === 'end' ? 'start' : last === 'start' ? 'end' : undefined : last].filter(Boolean).join('-');
  }
}
function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
var Popover = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var anchorElProp = _ref3.anchorEl,
    children = _ref3.children,
    _ref3$fixed = _ref3.fixed,
    fixed = _ref3$fixed === void 0 ? false : _ref3$fixed,
    _ref3$flip = _ref3.flip,
    flip = _ref3$flip === void 0 ? false : _ref3$flip,
    id = _ref3.id,
    _ref3$keepMounted = _ref3.keepMounted,
    keepMounted = _ref3$keepMounted === void 0 ? false : _ref3$keepMounted,
    _ref3$modifiers = _ref3.modifiers,
    modifiers = _ref3$modifiers === void 0 ? [] : _ref3$modifiers,
    onChangePlacement = _ref3.onChangePlacement,
    _ref3$open = _ref3.open,
    open = _ref3$open === void 0 ? false : _ref3$open,
    _ref3$placement = _ref3.placement,
    placementProp = _ref3$placement === void 0 ? 'bottom' : _ref3$placement,
    _ref3$portal = _ref3.portal,
    portal = _ref3$portal === void 0 ? false : _ref3$portal,
    portalContainer = _ref3.portalContainer,
    _ref3$role = _ref3.role,
    role = _ref3$role === void 0 ? 'tooltip' : _ref3$role,
    style = _ref3.style,
    _ref3$transition = _ref3.transition,
    transition = _ref3$transition === void 0 ? false : _ref3$transition,
    popoverProps = _objectWithoutProperties(_ref3, _excluded);
  var tooltipRef = React.useRef();
  var mergeTooltipRef = (0, _reactMergeRefs.default)([tooltipRef, ref]);
  var _useDirection = (0, _use_direction.default)(),
    isRTL = _useDirection.isRTL;
  var rtlPlacement = translatePlacement(placementProp, isRTL);
  var _React$useState = React.useState(rtlPlacement),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    placement = _React$useState2[0],
    setPlacement = _React$useState2[1];
  var _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    exited = _React$useState4[0],
    setExited = _React$useState4[1];
  var popperJsRef = React.useRef();
  React.useEffect(function () {
    if (popperJsRef.current) {
      popperJsRef.current.forceUpdate();
    }
  });
  var handleOpen = React.useCallback(function () {
    if (!tooltipRef.current || !open || !anchorElProp) {
      return;
    }
    if (popperJsRef.current) {
      popperJsRef.current.destroy();
      popperJsRef.current = undefined;
    }
    var anchorEl = getAnchorEl(anchorElProp);
    if (!anchorEl) {
      return;
    }
    var handlePopperUpdate = function handlePopperUpdate(newPlacement) {
      setPlacement(newPlacement);
      if (onChangePlacement) onChangePlacement(newPlacement);
    };
    var popperModifiers = [{
      name: 'preventOverflow',
      options: {
        altBoundary: portal
      }
    }, {
      name: 'flip',
      enabled: flip,
      options: {
        altBoundary: portal,
        boundary: 'viewport'
      }
    }, {
      name: 'onUpdate',
      enabled: true,
      phase: 'afterWrite',
      fn: function fn(_ref4) {
        var state = _ref4.state;
        handlePopperUpdate(state.placement);
      }
    }];
    var popperJs = (0, _core.createPopper)(anchorEl, tooltipRef.current, {
      strategy: fixed ? 'fixed' : 'absolute',
      placement: rtlPlacement,
      modifiers: [].concat(popperModifiers, _toConsumableArray(modifiers))
    });
    popperJsRef.current = popperJs;
    popperJsRef.current.forceUpdate();
  }, [anchorElProp, fixed, flip, modifiers, open, portal, rtlPlacement]); // eslint-disable-line

  var handleClose = function handleClose() {
    if (!popperJsRef.current) {
      return;
    }
    popperJsRef.current.destroy();
    popperJsRef.current = undefined;
  };
  var handleEnter = function handleEnter() {
    setExited(false);
  };
  var handleExited = function handleExited() {
    setExited(true);
    handleClose();
  };
  React.useEffect(function () {
    if (!open && !transition) {
      handleClose();
    }
  }, [open, transition]);
  React.useEffect(function () {
    // componentWillUnmount hook
    return function () {
      handleClose();
    };
  }, []);
  var handleRef = React.useCallback(function (node) {
    (0, _set_ref.default)(mergeTooltipRef, node);
    handleOpen();
  }, [handleOpen, mergeTooltipRef]);
  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  }
  var childProps = {
    placement: placement
  };
  if (transition) {
    childProps.transitionProps = {
      in: open,
      onEnter: handleEnter,
      onExited: handleExited
    };
  }
  return (0, _core2.jsx)(_portal.default, {
    disablePortal: !portal,
    container: portalContainer
  }, (0, _core2.jsx)("div", _extends({
    id: id,
    ref: handleRef,
    role: role
  }, popoverProps, {
    style: _objectSpread({
      display: !open && keepMounted && !transition ? 'none' : undefined,
      left: 0,
      position: fixed ? 'fixed' : 'absolute',
      right: 0
    }, style)
  }), typeof children === 'function' ? children(childProps) : children));
});
Popover.propTypes = _prop_types.default;
Popover.displayName = 'Popover';
var _default = exports.default = Popover;